import { experience } from "../../data/portfolio";
import styles from "./Experience.module.css";

export default function Experience() {
  return (
    <section id="experience" className={`section ${styles.experience}`}>
      <div className="sectionHeader">
        <p className="sectionEyebrow">Experience</p>
        <h2 className="sectionTitle">Where I’ve built &amp; shipped</h2>
        <p className="sectionLead">
          From frontend craft to AI-integrated full-stack systems — across product teams in India.
        </p>
      </div>

      <div className={styles.timeline}>
        {experience.map((job, index) => (
          <article key={job.company} className={styles.item} style={{ "--i": index }}>
            <div className={styles.marker} aria-hidden="true" />
            <div className={styles.content}>
              <div className={styles.top}>
                <div>
                  <h3>{job.role}</h3>
                  <p className={styles.company}>
                    {job.company} · {job.location}
                  </p>
                </div>
                <span className={styles.period}>{job.period}</span>
              </div>
              <p className={styles.summary}>{job.summary}</p>
              <ul>
                {job.highlights.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
